import { ProductUUID } from "namirasoft-api-product";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, EnumFormatter, ForeColorFormatter, IDFormatter, MoneyFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { InvoiceRow, PaymentRow, SubscriptionRow } from "namirasoft-payment";
import { PaymentRoutes } from "./PaymentRoutes";
import { PaymentMenus } from "./PaymentMenus";
import { PaymentProps } from "./PaymentProps";
import { NamirasoftMap } from "namirasoft-site-map";
import { IStorageLocal } from "namirasoft-core";

export class PaymentEntities
{
    static Subscription(props: NSARouterMakerResult & PaymentProps): IEntityInfo<SubscriptionRow, SubscriptionRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_PAYMENT,
            name: "subscription",
            tables: [{ table: namirasoft.payment.tables.subscription, required: true }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.sales_item_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.offer_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.date, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.gateway, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.status, new ForeColorFormatter(new EnumFormatter(), {
                            Active: "green",
                            Canceled: "red",
                            Incomplete: "grey",
                            IncompleteExpired: "red",
                            PastDue: "red",
                            Paused: "orange",
                            Trialing: "grey",
                            Unpaid: "grey"
                        })),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.subscription.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => PaymentRoutes.SubscriptionList(true, ""),
                getNewURL: null,
                getCopyURL: null,
                getEditURL: null,
                getViewURL: (id: string) => PaymentRoutes.SubscriptionView(id, true, ""),
                getMenus: (getIDs, getRows) => { return { "Cancel Subscription": [PaymentMenus.CancelSubscription(props, getIDs, getRows)] } },
            },

            server: {
                value_list: props.servers.payment.value.List,
                get: props.servers.payment.subscription.Get,
                list: props.servers.payment.subscription.List,
                create: null,
                update: null,
                delete: null,
            }
        };
    }
    static Payment(props: NSARouterMakerResult & PaymentProps): IEntityInfo<PaymentRow, PaymentRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
        return {
            product_id: ProductUUID.NAMIRASOFT_PAYMENT,
            name: "payment",
            tables: [{ table: namirasoft.payment.tables.payment, required: true }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.transaction_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.transaction_id_reversed, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.invoice_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.subscription_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.date, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.gateway, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.refund, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { false: "green", true: "red" })),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.status, new ForeColorFormatter(new EnumFormatter(), {
                            Incomplete: "orange",
                            Canceled: "grey",
                            Succeeded: "green",
                            Failed: "red"
                        })),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.currency, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.amount, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.payment.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => PaymentRoutes.PaymentList(true, ""),
                getNewURL: null,
                getCopyURL: null,
                getEditURL: null,
                getViewURL: (id: string) => PaymentRoutes.PaymentView(id, true, ""),
            },

            server: {
                value_list: props.servers.payment.value.List,
                get: props.servers.payment.payment.Get,
                list: props.servers.payment.payment.List,
                create: null,
                update: null,
                delete: null,
            }
        };
    }
    static Invoice(props: NSARouterMakerResult & PaymentProps): IEntityInfo<InvoiceRow, InvoiceRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_PAYMENT,
            name: "invoice",
            tables: [{ table: namirasoft.payment.tables.invoice, required: true }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.transaction_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.transaction_id_reversed, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.subscription_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.date, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.title, new StringFormatter(StringFormatterSizeType.TwoWords)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.refund, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { true: "red", false: "green" })),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.canceled, new ForeColorFormatter(new BooleanFormatter("Canceled", ""), { true: "red" })),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.total, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.total_fee, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.total_discount, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.total_tax, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.total_payable, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.total_paid, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.total_refunded, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.total_balance, new MoneyFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.currency, new StringFormatter(StringFormatterSizeType.Word)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.payment.tables.invoice.columns.updated_at, new DateTimeFormatter()),
                    ];
                },
                getListURL: () => PaymentRoutes.InvoiceList(true, ""),
                getNewURL: null,
                getCopyURL: null,
                getEditURL: null,
                getViewURL: (id: string) => PaymentRoutes.InvoiceView(id, true, ""),
                getMenus: (getIDs, getRows) =>
                {
                    return { "Pay": [PaymentMenus.PayInvoice(props, getIDs, getRows)] }
                },
            },

            server: {
                value_list: props.servers.payment.value.List,
                get: props.servers.payment.invoice.Get,
                list: props.servers.payment.invoice.List,
                create: null,
                update: null,
                delete: null,
            }
        };
    }
}